import { render, staticRenderFns } from "./activity_group.vue?vue&type=template&id=9accb188"
import script from "./activity_group.vue?vue&type=script&lang=js"
export * from "./activity_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports